import { Stack } from 'expo-router';

export default function AdminGlobalEventsLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
